module.exports = __webpack_public_path__ + "img/list.e9deeb.svg";